<template>
<div>

	<form @submit.prevent="validateBeforeSubmit">

		<div class="row">
			<div class="col-12 col-md-6">
				<div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Nome:</label>
					<div class="col-sm-10">
						<input type="text"
								name="descricao"
								v-validate="'required'"
								:class="{'is-invalid' : errors.has('descricao')}"
								v-model="form.categoria"
								class="form-control form-control-sm">
						<span  class="invalid-feedback" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
					</div>
				</div>

				<div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Sigla:</label>
					<div class="col-sm-10">
						<input type="text"
								name="sigla"
								v-validate="'required'"
								:class="{'is-invalid' : errors.has('sigla')}"
								v-model="form.sigla"
								class="form-control form-control-sm">
						<span  class="invalid-feedback" v-show="errors.has('sigla')">{{ errors.first('sigla') }}</span>
					</div>
				</div>

				<div class="form-group row">
					<label class="col-sm-2 col-form-label col-form-label-sm">*Data Revisão:</label>
					<div class="col-sm-6">
						<input v-model="form.dataAtualizacao" class="form-control form-control-sm" v-validate="'required'" style="display:none" name="dataAtualizacao" :class="{'is-invalid' : errors.has('dataAtualizacao')}" />
						<date-picker ref="date"
									:clearable="false"
									:input-class="'form-control form-control-sm ' + (errors.has('dataAtualizacao') ? 'is-invalid' : '' )"
									v-model="form.dataAtualizacao"
									format="DD/MM/YYYY"
									type="date"
									lang="pt-br"></date-picker>
						<span  class="invalid-feedback" v-show="errors.has('dataAtualizacao')">{{ errors.first('dataAtualizacao') }}</span>
					</div>
				</div>

				<div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Revisão:</label>
					<div class="col-sm-10">
						<input type="text"
								name="revisao"
								v-validate="'required|max:10'"
								:class="{'is-invalid' : errors.has('revisao')}"
								v-model="form.revisao"
								class="form-control form-control-sm">
						<span  class="invalid-feedback" v-show="errors.has('revisao')">{{ errors.first('revisao') }}</span>
					</div>
				</div>

				<div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Template:</label>
					<div class="col-sm-10">
						<select :disabled="form.id != 0"
								v-model="form.template"
								name="template"
								:class="{'is-invalid' : errors.has('template')}"
								v-validate="'required'"
								class="form-control form-control-sm">
							<option value="">ESCOLHA</option>
							<option value="AD_EASB_ASB">AD / EASB / ASB</option>
							<option value="SAFRAN_MM">SAFRAN - MM</option>
							<option value="AIRBUS_MSM_ALS">AIRBUS - MSM / ALS</option>
							<option value="AIRBUS_AMM">AIRBUS - AMM</option>
						</select>
						<span  class="invalid-feedback" v-show="errors.has('template')">{{ errors.first('template') }}</span>
					</div>
				</div>

				<div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Substituição:</label>
					<div class="col-sm-10">
						<toggle-button
									v-model="form.substituida"
									:width="120"
									:height="30"
									:sync="true"
									:value="form.substituida"
									:labels="{checked: 'ATIVADA', unchecked: 'DESATIVADO'}"
									:color="{checked: '#28a745', unchecked: '#dc3545'}"/>

						<br />

						<small class="text-info">Habilita um campo no cadastro de inspeção para assinalar qual à substitui. </small>
					</div>
				</div>

				<div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">AD/Boletim:</label>
					<div class="col-sm-10">
						<toggle-button
									v-model="form.adBoletim"
									:width="120"
									:height="30"
									:sync="true"
									:value="form.adBoletim"
									:labels="{checked: 'SIM', unchecked: 'NÃO'}"
									:color="{checked: '#28a745', unchecked: '#dc3545'}"/>

						<br />
					</div>
				</div>

				<div class="form-group row">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Formulário:</label>
					<div class="col-sm-10">

						<select v-model="form.formulario"
								name="formulario"
								class="form-control form-control-sm"
								:value="form.formulario">
							<option value="">ESCOLHA</option>
							<option value="FDCA">FDCA</option>
						</select>
						<span  class="invalid-feedback" v-show="errors.has('formulario')">{{ errors.first('formulario') }}</span>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6">

				<div class="form-group row"  v-for="i in showColunas" :key="i">
					<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Coluna {{i}}:</label>
					<div class="col-sm-10">
						<input type="text" v-model="form['c' + i]" class="form-control form-control-sm">
					</div>
				</div>

				<div class="row">
					<div class="col-sm-2" v-if="showColunas > 0"></div>
					<div class="col-sm-10">
						<button type="button" :disabled="showColunas == 30" @click="showColunas += 1" class="btn btn-outline-info btn-sm">
							<fa-icon icon="plus" /> Adicionar Coluna
						</button>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12 text-right">
				<hr />
				<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
				<button class="btn btn-success btn-sm">
					<fa-icon icon="check" transform="left-3" /> SALVAR
				</button>
			</div>
		</div>
	</form>
</div>
</template>

<style>
.ir {
	position: absolute;
    right: 20px;
    top: 4px;
}
</style>


<script>


import _ from 'lodash'
import axios from '../../../../routers/axios'
export default {

    data(){
        return {
			editar: false,
			showColunas: 0,
            form: {
				id: 0,
				idModelo: 0,
				categoria: null,
				revisao: null,
				sigla: null,
				template:  null,
				substituida: false,
				dataAtualizacao: null,
				adBoletim: false,
				formulario: '',
				c1: null,
				c2: null,
				c3: null,
				c4: null,
				c5: null,
				c6: null,
				c7: null,
				c8: null,
				c9: null,
				c10: null,
				c11: null,
				c12: null,
				c13: null,
				c14: null,
				c15: null,
				c16: null,
				c17: null,
				c18: null,
				c19: null,
				c20: null,
				c21: null,
				c22: null,
				c23: null,
				c24: null,
				c25: null,
				c26: null,
				c27: null,
				c28: null,
				c29: null,
				c30: null,

            }
        }
    },

    mounted () {
    },

    methods: {

        carregaDados (item, idModelo) {
			this.form.idModelo = idModelo
			if(item != null){
				this.editar = true
				this.form.id = item.id
				this.form.categoria = item.categoria
				this.form.revisao = item.revisao
				this.form.sigla = item.sigla
				this.form.template = item.template
				this.form.substituida = item.substituida
				this.form.dataAtualizacao = item.dataAtualizacao == '0001-01-01T00:00:00' ? '' : item.dataAtualizacao
				this.form.adBoletim = item.adBoletim,
				this.form.formulario = item.formulario,
				this.form.c1 = item.c1
				this.form.c2 = item.c2
				this.form.c3 = item.c3
				this.form.c4 = item.c4
				this.form.c5 = item.c5
				this.form.c6 = item.c6
				this.form.c7 = item.c7
				this.form.c8 = item.c8
				this.form.c9 = item.c9
				this.form.c10 = item.c10
				this.form.c11 = item.c11
				this.form.c12 = item.c12
				this.form.c13 = item.c13
				this.form.c14 = item.c14
				this.form.c15 = item.c15
				this.form.c16 = item.c16
				this.form.c17 = item.c17
				this.form.c18 = item.c18
				this.form.c19 = item.c19
				this.form.c20 = item.c20
				this.form.c21 = item.c21
				this.form.c22 = item.c22
				this.form.c23 = item.c23
				this.form.c24 = item.c24
				this.form.c25 = item.c25
				this.form.c26 = item.c26
				this.form.c27 = item.c27
				this.form.c28 = item.c28
				this.form.c29 = item.c29
				this.form.c30 = item.c30
				this.form.status = item.status
				this.form.dataStatus = item.dataStatus

				for(let i = 1; i <= 30; i++){
					if(this.form['c' + i] != null){
						this.showColunas += 1
					}
				}
			}

		},

        validateBeforeSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.salva();
                }
            });
        },

        salva(){

            var data = {
                id: this.form.id,
				idModelo: this.form.idModelo,
				categoria: _.trim(this.form.categoria),
				revisao:  _.trim(this.form.revisao),
				sigla:  _.trim(this.form.sigla),
				template: this.form.template,
				substituida: this.form.substituida,
				dataAtualizacao: this.form.dataAtualizacao,
				adBoletim: this.form.adBoletim,
				formulario: this.form.formulario,
				c1: this.form.c1,
				c2: this.form.c2,
				c3: this.form.c3,
				c4: this.form.c4,
				c5: this.form.c5,
				c6: this.form.c6,
				c7: this.form.c7,
				c8: this.form.c8,
				c9: this.form.c9,
				c10: this.form.c10,
				c11: this.form.c11,
				c12: this.form.c12,
				c13: this.form.c13,
				c14: this.form.c14,
				c15: this.form.c15,
				c16: this.form.c16,
				c17: this.form.c17,
				c18: this.form.c18,
				c19: this.form.c19,
				c20: this.form.c20,
				c21: this.form.c21,
				c22: this.form.c22,
				c23: this.form.c23,
				c24: this.form.c24,
				c25: this.form.c25,
				c26: this.form.c26,
				c27: this.form.c27,
				c28: this.form.c28,
				c29: this.form.c29,
				c30: this.form.c30,
				status: this.form.status,
				dataStatus: this.form.dataStatus
            }

            this.$notify.loadIn('Salvando')

            if(this.editar){

                axios.put(this._getUrl('api/ConfigInspecao') + '/' + this.form.id, data).then(response => {
                    this.$emit('item-salvo', response.data)

                })

            } else {

                axios.post(this._getUrl('api/ConfigInspecao'), data).then(response => {
                    this.editar = true
                    this.$emit('item-salvo', response.data)
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/followair/manutencao/cadastro/categoria.vue